<template>
  <div v-if="state.data && state.data.is_employee" class="form-holder organization-setting">
    <label for="profile-organization">Організація</label>
    <select id="profile-organization" v-model="selected" class="input" :disabled="state.saving">
      <option value="" disabled>Оберіть організацію</option>
      <option v-for="item in state.data.organizations" :key="item.id" :value="item.id">{{ item.name }}</option>
    </select>
    <button type="button" class="btn btn-main" :disabled="!validSelection || state.saving || state.loading" @click="save">Зберегти організацію</button>
    <p v-if="saved" role="status">Організацію збережено.</p>
    <p v-if="state.error" role="alert">{{ state.error }}</p>
  </div>
</template>

<script>
import { organizationFlow } from '../../helpers/requestOrganization'

export default {
  data: () => ({ state: organizationFlow.state, selected: '', saved: false }),
  mounted () { organizationFlow.refresh().catch(() => {}) },
  computed: {
    validSelection () {
      return this.state.data && this.state.data.is_employee && this.state.data.organizations.some(item => String(item.id) === String(this.selected))
    }
  },
  watch: {
    'state.data': {
      immediate: true,
      handler (data) {
        this.selected = data && data.is_employee && data.organization_id !== null ? data.organization_id : ''
        this.saved = false
      }
    },
    selected () { this.saved = false }
  },
  methods: {
    async save () {
      const saved = await organizationFlow.replace(this.selected)
      this.$nextTick(() => { this.saved = saved })
    }
  }
}
</script>

<style scoped>
.organization-setting { padding: 20px 0; }
.organization-setting select { width: 100%; margin: 12px 0; }
</style>
